const PAYER = 'payer';
const USER = 'user';

const template = (_, arg) =>
  `This ${arg} is not active so the function cannot be performed`;

export const PAYER_INACTIVE_MESSAGE = template`${PAYER}`;
export const PAYER_USER_INACTIVE_MESSAGE = template`${USER}`;

export const NO_ACTIVE_PAYER_USERS_MESSAGE =
  'No active payer users are linked to this payer. Load payer users or select a different payer.';
